import React, {useState, useEffect, useContext, useRef } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonFooter, IonInput, IonText, IonLoading, IonLabel } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import '../css/clientCss.css';
import { ViewAttachement_ImageModal } from '../../zInternal_Features/merchant/components/Modal_ViewAttachement_Image';
import { ViewInvoiceModal } from '../../zInternal_Features/merchant/components/Modal_ViewInvoice';

import {v4 as uuid} from 'uuid';

export function ActiveOrderDetailsModal(props) {


    let authClient_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authClient_context.acctID);
    const [schema, setSchemaName] = useState(authClient_context.schema);
    let [sessionID, setSessionID ] = useState(authClient_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authClient_context.baseURL);

    let [viewEstimateDetailData, setViewEstimateDetailData] = useState([]);


    let [merchantAccountID, setMerchantAccountID] = useState(null);
    let [merchantOrderID, setMerchantOrderID] = useState(null);

    let [orderID, setOrderID] = useState(null);
    let [orderTotal, setOrderTotal] = useState(null);
    let [orderPhoneNumber, setOrderPhoneNumber] = useState(null);
    let [clientMemberNumber, setClientMemberNumber] = useState(null);

    let [totalAmount, setTotalAmount] = useState(null);
    let [paymentType, setPaymentType] = useState(null);
    let [imageAttachement, setImageAttachement] = useState(null);
    let [viewAttachementModal, setViewAttachemntModal] = useState(false);

    let [viewOrderDetailsList, setViewOrderDetailsList] = useState([]);
    let [viewTransactions, setViewTransactions] = useState([]);
    let [showInvoiceModal, setViewInvoiceModal] = useState(null);
    let [invoiceForm, setInvoiceForm] = useState(null);
    let [transactionID, setTransactionID] = useState(null);


    let [orderName, setOrderName] = useState(null);
    let [invoiceID, setInvoiceID] = useState(null);
    let [invoiceTotal, setInvoiceTotal] = useState(null);
    let [merchantInvoiceID, setMerchantInvoiceID] = useState(null);
    let [customerInvoiceID, setCustomerInvoiceID] = useState(null);

    let [orderDescription, setOrderDescription] = useState([]);

    let [displaySetButton_pay, setDisplaySetButton_pay] = useState('inline-block');
    let [displayResetButton_pay, setDisplayResetButton_pay] = useState('none');
    let [disableSetButton_pay, setDisableSetButton_pay] = useState(false);
    let [disableResetButton_pay, setDisableResetButton_pay] = useState(false);

    let [disablePayButton, setDisablePayButton] = useState(false);

    let [isloading, setLoading] = useState(false);

    let enterPayRef = useRef(0);
    let paymentTypeRef = useRef('MTN-MOMO');

    let [expenseID, setExpenseID] = useState(null);


    const parseArray = (raw) => {
    try {
        let v = raw;
        if (typeof v === "string") v = JSON.parse(v);
        while (typeof v === "string" && (/^\s*[\[{]/.test(v))) v = JSON.parse(v);
        return Array.isArray(v) ? v : [];
    } catch {
        console.warn("Bad itemID_list JSON:", raw);
        return [];
    }
    };
    
   //getOccupiedRoomDetailData(instant_checkInRoomID) {
    function getOrderDetails() {

        const requestOptions = {
            method: 'POST',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
            },
            body: JSON.stringify({
                Tracker: 'uu_view_orders_details',
                user: acctID,
                xOrderID: props.data.orderID,
                sessionID: sessionID,
            }),
        };

        fetch(baseURL + 'userAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
                let rows = res.toString().split('~~~');
                let cols;

                for (let rownum = 0; rownum < rows.length - 1; ++rownum) {
                    cols = rows[rownum].split('|');


                    setViewOrderDetailsList((prevAvailableProducts) => {
                        return prevAvailableProducts.concat({
                            order_id: cols[0],
                            cart_id: cols[1],
                            order_phone_number: cols[2],
                            client_first_name: cols[3],
                            client_last_name: cols[4],
                            client_phone_number: cols[5],
                            client_email_address: cols[6],
                            client_payment_type: cols[7],
                            client_member_number: cols[8],
                            client_mm_provider: cols[9],
                            client_mm_number: cols[10],
                            order_total: parseFloat(cols[11]).toFixed(2),
                            order_amt_paid: parseFloat(cols[12]).toFixed(2),
                            order_start_date_reserved: cols[13],
                            order_end_date_reserved: cols[14],
                            order_start_date: cols[15],
                            order_end_date: cols[16],
                            merchant_invoice_id: cols[17],
                            invoiceForm: cols[18],
                            customer_invoice_id: cols[19],
                            invoiceTotal: parseFloat(cols[20]).toFixed(2),
                            transactionID: cols[21],
                            totalInvoiceAmount: cols[22],
                            transactionStatus: cols[23],
                            momo_provider: cols[24],
                            momo_financial_transaction_id: cols[25],
                            momo_external_id: cols[26],
                            momo_amount: cols[27],
                            momo_party_id: cols[28],
                            momo_payer_message: cols[29],
                            momo_payee_note: cols[30],
                            momo_pay_status: cols[31],
                            payment_type: cols[32],
                            verify_id_type: cols[33],
                            verify_id_number: cols[34],
                            ship_to_address: cols[35],
                            latitude: cols[36],
                            longitude: cols[37],
                            status: cols[38],
                            merchantAccountID: cols[39],
                            merchantOrderID: cols[40],
                            orderDescription: cols[41],

                        });
                    });

                    setOrderID(cols[0]);
                    setOrderPhoneNumber(cols[2]);
                    setOrderName(cols[3]+"_"+cols[4])
                    setMerchantInvoiceID(cols[17]);
                    setCustomerInvoiceID(cols[19]);
                    
                    setClientMemberNumber(cols[8]);
                    setMerchantAccountID(cols[39]);
                    setMerchantOrderID(cols[39]);
                    setOrderDescription(parseArray(cols[41]));


                }

                let rows2 = cols[21].toString().split('_');


                for (let rownum = 0; rownum < rows2.length - 1; ++rownum) {
                    let cols2 = rows2[rownum].split('#');


                    setViewTransactions((prevViewTransactions) => {
                        return prevViewTransactions.concat({
                            transactionID: cols2[0],
                            amount: cols2[1],
                            momo_pay_status: cols2[2],
                            transactionStatus: cols2[3],
                            payment_type: cols2[4],

                        });
                    });
                }
            });
    
    }


    function conver_to_consult()
    {
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74101_convert_to_consult',
                user: acctID,
                xEstimateID: props.data.estimateID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
        })
    }

    function submitPay(event)
    {

        setDisablePayButton(true);
        setLoading(true);


        if (paymentTypeRef.current.value == 'CASH')
        {
            prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value]);

            return;
        }
        return new Promise((resolve, reject) => {


            const customerPayAmount = parseFloat(event[5]).toFixed(2);
            const payCurrency = 'GHS';
            //const payExternalId = '';
            const payPartyId = event[3].replace(/^0+/, '');
            const payPayerMessage = event[7] + " Momo Payment";
            const payPayeeNote = "Bluefin Hotel Invoice";

            const apiuser = "824b5de8-0af9-4757-939b-f50992a0427f";
            const apikey = "e288a3938db14c8c9dfe3543427a141e";
            const concatenatedString = `${apiuser}:${apikey}`;
            const base64EncodedString = window.btoa(concatenatedString);

            let xReferenceID = uuid();

            //alert("BEFORE PAY");
            //alert(merchantPhoneNumber.replace(/^0+/, ''));
            //alert(merchantPhoneNumber);

            fetch(baseURL+'mtnapi/collection/token/', {
                method: 'POST',                                                                                                                                                                                                                 
                credentials: 'include',
                //mode: 'no-cors',
                //body: '',
                //Request headers
                headers: {
                    'authorization': 'Basic '+ base64EncodedString,
                    //'cache-Control': 'no-cache',
                    //'content-_type': 'application/json',
                    'ocp-apim-subscription-key': 'c4f861935bb543cbba9f3762cf13fd9e',
                    'x-target-environment': 'mtnghana',
                    'x-reference-id': xReferenceID.toString(),
                    'tracker': '74108_B_update_successful_retail_addition',
                    'user': acctID,
                    'x_company_id_public': merchantAccountID,
                    'x_merchant_mobilenumber': orderPhoneNumber.replace(/^0+/, ''),
                    'x_ProjectID': "N/A",
                    'x_customer_mobilenumber': event[3],
                    'x_invoice_id': event[1],
                    'x_customer_invoice_id': event[2],
                    'x_immediate_destination': merchantAccountID,
                    'x_check_in_amount': parseFloat(event[5]).toFixed(2),
                    'session_id': sessionID,
                    'momo_url': 'collection/v1_0/requesttopay',
                    'confirm_payment': 'confirm_or_reject',
                    // 'request_to_pay': JSON.stringify({
                    //     "amount": customerPayAmount,
                    //     "currency": payCurrency,
                    //     "externalId": xReferenceID.toString(),
                    //     "payer": {
                    //         "partyIdType": "MSISDN",
                    //         "partyId": "233"+payPartyId
                    //     },
                    //     "payerMessage": payPayerMessage,
                    //     "payeeNote": payPayeeNote
                    // }),
                    'customer_pay_amount': customerPayAmount,
                    'pay_currency': payCurrency,
                    'external_id': xReferenceID.toString(),
                    'party_id_type': 'MSISDN',
                    'party_id': payPartyId,
                    'pay_payer_message': payPayerMessage,
                    'pay_payee_note': payPayeeNote,

                },

            })
            .then(res => res.json())
            .then(res => {


                prepareInvoice_thenConfirmPay_nonMember([event, paymentTypeRef.current.value, 'MTN', res.financialTransactionId, res.externalId, res.amount, 'GHS', res.payer.partyIdType, res.payer.partyId, res.payerMessage, res.payeeNote, res.status, acctID]);

            })
        })
    }

    function prepareInvoice_thenConfirmPay_nonMember(event)
    {
                

        if(event[0][8] == "partial_paid")
        {

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74108_B',
                    user: acctID,
                    xCompanyID_public: merchantAccountID,
                    xCustMobileNumber: event[0][3],
                    xInvoiceID: event[0][1],
                    xCustomerInvoiceID: event[0][2],
                    xImmediateDestination: merchantAccountID,
                    xCheckInCashAmount: parseFloat(event[0][5]).toFixed(2),
                    sessionID: sessionID,
                    xPaymentType: event[1],
                    xUserStatus: "member",
                    xMomo_provider: event[2],
                    xMomo_financial_transaction_id: event[3],
                    xMomo_external_id: event[4],
                    xMomo_amount: event[5],
                    xMomo_currency: event[6],
                    xmomo_party_id_type: event[7],
                    xMomo_party_id: event[8],
                    xMomo_payer_message: event[9],
                    xMomo_payee_note: event[10],
                    xMomo_pay_status: event[11],
    
                }),
            }

            fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(data => {

                confirmPayment_non_member([data, event[0][1], event[0][2], event[0][3], event[0][4], event[0][6], event[1], event[2], event[3], event[4], event[5], event[6], event[7], event[8], event[9], event[10], event[11]]);

            })
            .catch(error => {
                console.error(error);
            })

        }
 
    }

    let intervalID;

    function confirmPayment_non_member(event)
    {
        // alert("in Confrim Payment - nonmember");
        // alert(event);
        // alert(event[6]);

        let transactionID = event[0];
        let customerInvoiceID = event[2]; //undefined
        let customerPhoneNumber = event[3];
        let tracker = event[4];


        /*const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: tracker,
                user: event[20],
                xCompanyID_public: merchantAccountID,
                xInvoiceID: event[18],
                xZInvoiceID: event[19],
                xCustomerInvoiceID: customerInvoiceID, //undefined
                xTransactionID: transactionID,
                xCustMobileNumber: customerPhoneNumber,
                xOrderID: event[17],
                sessionID: sessionID,
                xPaymentType: event[6],
                xUserStatus: "member",
                xMomo_provider: event[7],
                xMomo_financial_transaction_id: event[8],
                xMomo_external_id: event[9],
                xMomo_amount: event[10],
                xMomo_currency: event[11],
                xmomo_party_id_type: event[12],
                xMomo_party_id: event[13],
                xMomo_payer_message: event[14],
                xMomo_payee_note: event[15],
                xMomo_pay_status: event[16],
                

            }),
        }

        fetch(baseURL+'ghanaverified/', requestOptions)
        .then(res => res.text())
        .then(data => {

            //alert("before loading");
            //alert("INITIAL PAYMENT REQUEST SENT.  PENDING CUSTOMER APPROVAL.");
            //alert(data);

            // if(isloading == true)
            // {
            //     alert("Please approve MTN momo request");
            //     setTimeout(getMomoStatus(transactionID), 5000);
            */

            if(event[6] == "mm" || event[6] == "MTN-MOMO")
            {
                intervalID = setInterval(() => {                                
                                    
                                            const requestOptions = {
                                                method: 'POST',
                                                //credentials: 'include',
                                                headers: {
                                                    'Accept': 'text/html, application/json',
                                                    'content-type': 'application/json',
                                                    //'cookie': 'cookie',
                                                },
                                                body: JSON.stringify({
                                                    Tracker: '74605_B_retail_public_check_payStatus',
                                                    user: acctID,
                                                    xCompanyID_public: merchantAccountID,
                                                    xTransactionID: transactionID,
                                                    sessionID: sessionID,
                                                    
                                                }),
                                            }
                                    
                                            fetch(baseURL+'ghanaverified/', requestOptions)
                                            .then(res => res.text())
                                            .then(data => {
                                                                        
                                                let rows = data.toString().split('~~~');
                                                //clearInterval(intervalID);

                                                
                                                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                                                {
                                                    let cols = rows[rownum].split('|');
                                    
                                                    if(cols[1] == "C" && cols[2] == "SUCCESSFUL")
                                                    {

                                                        //alert('PAYMENT SUCESSFUL.  YOU SHOULD RECIEVE INVOICE VIA TEXT.  YOUR RETAIL INVOICE ID IS '+cols[0]);
                                                        alert('PAYMENT SUCESSFUL. YOUR RETAIL INVOICE ID IS '+cols[0]);

                                                        clearInterval(intervalID);

                                                        setLoading(false);

                                                        //authMerchant_objects.changeAuthenticated(authenticated);

                                                        //merchantLoginModal(false);
                                                        //history.push('/home');
                                                        window.location.href = '/';

                                                       // props.closeModal([cols[2], event[17], event[21], event[20]]);

                                                    }
                                                    else if(cols[2] == "NO_RESPONSE")
                                                    {

                                                        alert('PAYMENT UNSUCESSFUL. '+cols[2]+'.  PLEASE TRY AGAIN');

                                                        clearInterval(intervalID);
                                                        setLoading(false);
                                                        //authMerchant_objects.changeAuthenticated(authenticated);
                                                        //merchantLoginModal(false);
                                                        //props.closeModal([cols[2], event[17]]);
                                                        window.location.href = '/';


                                                    }
                                                    else
                                                    {
                                                        //alert("PLEASE APPROVE MOMO PAYMENT");

                                                        setLoading(true);
                                                        //clearInterval(intervalID);

                                                    }
                                    
                                                }
                                    
                                            })
            
                  }, 5000); //5 seconds
                }
                else
                {
                    alert("INITIAL PAYMENT REQUEST SENT.  PENDING MERCHANT APPROVAL.");
                    setLoading(false);
                    window.location.href = '/';
                }
            // }
            // else
            // {
                //clearTimeout();
            // }

            //props.closeModal();
      //  })
    }


    function setPayHandler()
    {
        setDisableSetButton_pay(true);
        setDisplaySetButton_pay('none');
        setDisableResetButton_pay(false);
        setDisplayResetButton_pay('inline-block');

    }

    function resetPayHandler()
    {
        setDisableResetButton_pay(true);
        setDisplayResetButton_pay('none');
        enterPayRef.current.value = '';
        setDisableSetButton_pay(false);
        setDisplayResetButton_pay('none');
        setDisplaySetButton_pay('inline-block');
    }

    function viewExpenseAttachmentHandler(event) {

        //alert('In viewExpenseInvoiceHandler');
        //alert(event);
        //alert(event[0]);
        //alert(event[3]);
        //alert(event[4]);
        //alert(event[5]);

        setTotalAmount(event[3]);
        setPaymentType(event[4]);
        setImageAttachement(event[5]);

        setViewAttachemntModal(event[0]);

        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }

    function viewEstimateAttachmentHandler(event) {

        //alert('In viewEstimateInvoiceHandler');
        //alert(event);
        //alert(event[0]);
        //alert(event[3]);
        //alert(event[4]);
        //alert(event[5]);

        // setTotalAmount(event[3]);
        // setPaymentType(event[4]);
        setImageAttachement(event[1]);

        setViewAttachemntModal(event[0]);

        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }
    function viewInvoiceModalHandler(event) {

        //alert(event);

        setOrderID(event[1]);
        setOrderTotal(event[2]);
        setInvoiceForm(event[3]);
        setViewInvoiceModal(event[0]);

    }
    
    function closeModalHandler() {

        setViewEstimateDetailData([]);
        props.closeModal(false);
    }


    useEffect(() =>
    {
        getOrderDetails();

    }, [])

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonHeader style={{color: "black"}}>
            <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <h3>ORDER DETAILS</h3>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'> Order ID</IonCol>
                        <IonCol size='6'> Order Total</IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'> {props.data.orderID} </IonCol>
                        <IonCol size='6'> {props.data.orderTotal} </IonCol>
                    </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent className='grid_content'>

        {viewOrderDetailsList.map((detailData) =>   {
            return (
            <IonGrid>
                <IonRow >
                    <IonCol size='3' ><h3>Category</h3></IonCol>
                    <IonCol size='6' ><h3>Value</h3></IonCol>
                    <IonCol size='3' ><h3>Action</h3></IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' ><IonLabel>Invoice</IonLabel></IonCol>
                    <IonCol size='6' ><IonText className='professional-text'>{detailData.merchant_invoice_id}</IonText></IonCol>
                    <IonCol size='3' >
                        <IonButton  onClick={() => viewInvoiceModalHandler([true, detailData.order_id, detailData.order_total, detailData.invoiceForm])}> View </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Guest Contact</IonCol>
                    <IonCol size='6' style={{fontSize: 'small'}}>{ 'Name: '+detailData.client_first_name+' '+detailData.client_last_name+
                                                        ', Phone #: '+detailData.client_phone_number+
                                                        ', Email: '+detailData.client_email_address}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Payment Type</IonCol>
                    <IonCol size='6' >{detailData.payment_type}</IonCol>
                    <IonCol size='3' >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Amount Paid</IonCol>
                    <IonCol size='6' >{detailData.order_amt_paid}</IonCol>
                    <IonCol size='3' >
                        <IonButton  > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='3' >Balance</IonCol>
                    <IonCol size='6' >{parseFloat(detailData.order_total - detailData.order_amt_paid).toFixed(2)}</IonCol>
                    <IonCol size='3' >
                        <IonButton  > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow className="outlinedRow">
                    <IonCol >DESCRIPTION</IonCol>
                </IonRow>
                <IonRow className="outlinedRow outlinedHeader">
                    <IonCol size='2'>ID</IonCol>
                    <IonCol size='4'>NAME</IonCol>
                    <IonCol size='3'>PRICE</IonCol>
                    <IonCol size='3'>QTY</IonCol>
                </IonRow>
                {orderDescription.map((it) => {
                    return (
                        <IonRow className="outlinedRow">
                            <IonCol size='2'>
                                {it.id}
                            </IonCol>
                            <IonCol size='4'>
                                {it.name}
                            </IonCol>
                            <IonCol size='3'>
                                {it.price}                              
                            </IonCol>
                            <IonCol size='3'>
                                {it.quantity}                              
                            </IonCol>
                        </IonRow>
                    )}
                )}
                {/*<IonRow >
                    <IonCol size='12'>
                        <select name="payemntType" id='payemntType' ref={paymentTypeRef }>
                            <option value='CASH'>Cash</option>
                            <option value='MTN-MOMO' selected>Mobile Money</option>
                        </select>
                    </IonCol>
                    <IonCol size='3' >Pay</IonCol>
                    <IonCol size='6'>
                        <IonInput style={{display: displaySetButton_pay}} type='number' placeholder='Enter %' ref={enterPayRef}></IonInput>
                        <h4 style={{display: displayResetButton_pay}}>{enterPayRef.current.value+' GH'}</h4>
                    </IonCol>
                    <IonCol size='3'>
                        <IonButton style={{display: displaySetButton_pay}} disabled={disableSetButton_pay} onClick={() => setPayHandler()}>Set</IonButton>
                        <IonButton style={{display: displayResetButton_pay}} disabled={disableResetButton_pay} onClick={() => resetPayHandler()}>Reset</IonButton>
                    </IonCol>
                </IonRow >*/}
                <IonRow >
                    <IonCol size='3' >Pay-To-Invoice</IonCol>
                    <IonCol size='6'>
                        <IonInput style={{display: displaySetButton_pay}} type='number' placeholder='Enter %' ref={enterPayRef}></IonInput>
                        <h4 style={{display: displayResetButton_pay}}>{enterPayRef.current.value+' GH'}</h4>
                    </IonCol>
                    <IonCol size='3'>
                        <IonButton style={{display: displaySetButton_pay}} disabled={disableSetButton_pay} onClick={() => setPayHandler()}>Set</IonButton>
                        <IonButton style={{display: displayResetButton_pay}} disabled={disableResetButton_pay} onClick={() => resetPayHandler()}>Reset</IonButton>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <select name="payemntType" id='payemntType' ref={paymentTypeRef }>
                            <option value='CASH'>Cash</option>
                            <option value='MTN-MOMO' selected>Mobile Money</option>
                        </select>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        {(authClient_context.accessRights[0] == 'admin' || authClient_context.accessRights[0] == 'manager') && <IonButton id='gridResultColumnButton'  disabled={disablePayButton} onClick={() => submitPay([transactionID, merchantInvoiceID, customerInvoiceID, orderPhoneNumber, '74605_B', enterPayRef.current.value, orderID, orderName, "partial_paid"])}> PAY</IonButton>}
                    </IonCol>
                </IonRow>
            </IonGrid>
            
                    )
                }
            )}

            {viewTransactions.map((detailData2) =>   {
                    return (
                        <IonGrid>
                            {detailData2.payment_type == 'CASH' && 
                            <IonRow >
                                <IonCol size='4'>
                                    <IonText>{detailData2.payment_type}</IonText>
                                </IonCol>
                                <IonCol size='4'>
                                    <IonText>{detailData2.amount}</IonText>
                                </IonCol>
                                <IonCol size='4' >
                                    {((authClient_context.accessRights[0] == 'admin' || authClient_context.accessRights[0] == 'manager') && (detailData2.momo_pay_status == '' || detailData2.momo_pay_status == 'NO_RESPONSE' || detailData2.momo_pay_status == 'FAILED' || detailData2.momo_pay_status == 'N/A' || detailData2.momo_pay_status == 'SUCCESSFUL' || detailData2.momo_pay_status == 'CASH')) &&   <IonText >PAID</IonText>}
                                    {((authClient_context.accessRights[0] == 'admin' || authClient_context.accessRights[0] == 'manager') && detailData2.momo_pay_status  == 'PENDING') &&   <IonButton id='gridResultColumnButton' disabled={true} > Pending</IonButton>}
                                </IonCol>
                            </IonRow>
                            }
                            {(detailData2.payment_type == 'mm' || detailData2.payment_type == 'MTN-MOMO') && 
                            <IonRow >
                                <IonCol size='4'>
                                    <IonText>{detailData2.payment_type}</IonText>
                                </IonCol>
                                <IonCol size='4'>
                                    <IonText>{detailData2.amount}</IonText>
                                </IonCol>
                                <IonCol size='4' >
                                    {((authClient_context.accessRights[0] == 'admin' || authClient_context.accessRights[0] == 'manager') && (detailData2.momo_pay_status == '' || detailData2.momo_pay_status == 'NO_RESPONSE' || detailData2.momo_pay_status == 'FAILED' || detailData2.momo_pay_status == 'N/A' || detailData2.momo_pay_status == 'SUCCESSFUL' || detailData2.momo_pay_status == 'CASH')) &&   <IonText >PAID</IonText>}
                                    {((authClient_context.accessRights[0] == 'admin' || authClient_context.accessRights[0] == 'manager') && detailData2.momo_pay_status  == 'PENDING') &&   <IonButton id='gridResultColumnButton' disabled={true} > FAILED</IonButton>}
                                </IonCol>
                            </IonRow>
                            }
                        </IonGrid>
                            )}
                    )}

                {isloading == true && <IonLoading
                        isOpen={isloading}
                        message={'Please wait...'}
                        duration={0} // Show until manually dismissed
                    />}

    
                {showInvoiceModal == true && <ViewInvoiceModal openModal={ showInvoiceModal } closeModal={() => setViewInvoiceModal(false)} data={{
                                fileLocation: `/api/form/${invoiceForm}/${schema}`, 
                                }}></ViewInvoiceModal>}

        </IonContent>


        <IonFooter className='grid_footer'>
                <IonGrid>
                    <IonRow>
                        <IonCol size="12">
                            <IonButton onClick={closeModalHandler}> Close </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonFooter>

    </IonModal>) : null}
    </React.Fragment>
    )
}